module.exports = __webpack_public_path__ + "img/youtube_blue.e6c64528.svg";